import { render } from "./DataMapperStreaming.vue?vue&type=template&id=4a4808de&scoped=true"
import script from "./DataMapperStreaming.vue?vue&type=script&lang=js"
export * from "./DataMapperStreaming.vue?vue&type=script&lang=js"

import "./DataMapperStreaming.vue?vue&type=style&index=0&id=4a4808de&lang=scss&scoped=true"
import "./DataMapperStreaming.vue?vue&type=style&index=1&id=4a4808de&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4808de"]])

export default __exports__